import {Component, OnDestroy, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {take, takeUntil} from 'rxjs/operators';
import {AuthService} from '../../services/auth.service';
import {UserModel} from '../../models/User';
import {WaitlistModalComponent, WaitlistMode} from '../modals/waitlist-modals/waitlist-modal.component';
import {DialogService} from 'primeng/dynamicdialog';
import {ButtonModule} from 'primeng/button';
import {NavigationEnd, Router} from '@angular/router';
import {filter} from 'rxjs/internal/operators/filter';
import {Subject} from 'rxjs/internal/Subject';

@Component({
    selector: 'app-waitlist-banner',
    templateUrl: './waitlist-banner.component.html',
    standalone: true,
    imports: [CommonModule, ButtonModule]
})

export class WaitlistBannerComponent implements OnInit, OnDestroy {
    user: UserModel
    hideBanner = false;
    private destroy$ = new Subject<void>();


    constructor(private auth: AuthService, private dialogService: DialogService, private router: Router) { }
    ngOnInit(): void {
        this.router.events
            .pipe(
                filter(e => e instanceof NavigationEnd),
                takeUntil(this.destroy$)
            )
            .subscribe((e: NavigationEnd) => {
                const url = e.urlAfterRedirects || e.url;

                this.hideBanner = url.startsWith('/signup') ||
                    url.startsWith('/login') ||
                    url.startsWith('/deals');
            });

        this.auth.user$
            .pipe(takeUntil(this.destroy$))
            .subscribe(user => {
                this.user = user || null;
            });
        void this.auth.loadSession().pipe(take(1)).subscribe();
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    openWaitlistModal(){
        this.dialogService.open(WaitlistModalComponent, {
            data: {
                isVisible: true,
                mode: WaitlistMode.upgrade,
            },
            width: '400px',
            breakpoints: {
                '768px': '100%'
            },
            showHeader: false,
            styleClass: 'dashboard-modal',
            dismissableMask: true,
            appendTo: document.body,
            contentStyle: {
                padding: '10px',
                scrollbarWidth: 'none'
            }
        });
    }
}
